import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { Link } from 'gatsby';

import '../../styles/solution-item.css';

import { _ } from '../../utils/l10n';
import { BaseButtonLink } from '../generic/ButtonLink';
import { BaseDetailSummaryItemProps, DetailSummaryItemInfo } from '../DetailSummaryItemInfo';
import { SolutionOverviewTag } from './SolutionOverviewTag';
import { ArrowButton } from '../generic/ArrowButton';

export interface SolutionOverviewItemProps extends BaseDetailSummaryItemProps {
  /**
   * Image data
   */
  image?: IGatsbyImageData;
  /**
   * Image alt text.
   */
  imageAlt?: string;
  /**
   * Link data
   */
  link?: BaseButtonLink;
  /**
   * Solution target group
   */
  targetGroup?: string;
  /**
   * Additional description displayed in expandable read more
   */
  longDesc?: string;
  /**
   * Whether the whole tile is clickable or just the arrow button
   */
  isTileClickable?: boolean;
  /**
   * Content passed as children
   */
  children?: React.ReactNode;
}

// @todo DRY, refactor
export const SolutionOverviewItem = ({
  title,
  description,
  image,
  imageAlt,
  link,
  targetGroup,
  longDesc,
  children,
  isTileClickable = true,
}: SolutionOverviewItemProps) => (
  <li>
    <div className="solution-overview-item">
      {isTileClickable ? (
        <Link to={link?.href || ''}>
          <div className="solution-overview-item-content">
            <DetailSummaryItemInfo
              title={title}
              description={description}
              longDesc={longDesc}
            />
            {targetGroup && <SolutionOverviewTag label={targetGroup} />}
            {children}
            <ArrowButton />
          </div>
          {image && (
            <GatsbyImage
              image={image}
              alt={imageAlt ?? ''}
              loading="lazy"
            />
          )}
        </Link>
      ) : (
        <div className="solution-overview-item-content">
          <DetailSummaryItemInfo
            title={title}
            description={description}
            longDesc={longDesc}
          />
          {targetGroup && <SolutionOverviewTag label={targetGroup} />}
          {children}
          <Link to={link?.href || ''} className='arrow-button-link'>
            <ArrowButton />
          </Link>
          {image && (
            <GatsbyImage
              image={image}
              alt={imageAlt ?? ''}
              loading="lazy"
            />
          )}
        </div>
      )}
    </div>
  </li>
);
